import React from 'react';
interface HeroProps {
  title: string;
  subtitle?: string;
  buttonText?: string;
  buttonLink?: string;
  backgroundImage: string;
}
export const Hero = ({
  title,
  subtitle,
  buttonText,
  buttonLink = '/contact-us',
  backgroundImage
}: HeroProps) => {
  return <div className="relative bg-dark w-full" data-id="element-141">
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url(${backgroundImage})`
    }} data-id="element-142">
        <div className="absolute inset-0 bg-gradient-to-r from-dark/80 to-dark/50" data-id="element-143"></div>
      </div>
      <div className="container mx-auto px-4 py-20 md:py-32 relative z-10" data-id="element-144">
        <div className="max-w-2xl" data-id="element-145">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-146">
            {title}
          </h1>
          {subtitle && <p className="text-xl text-white/90 mb-8 max-w-lg" data-id="element-147">{subtitle}</p>}
          {buttonText && <a href={buttonLink} className="inline-block bg-secondary hover:bg-secondary/90 text-white font-bold py-3 px-8 rounded-md text-lg transition-colors" data-id="element-148">
              {buttonText}
            </a>}
        </div>
      </div>
    </div>;
};